export default __webpack_public_path__ + "static/media/offline.acfa0d1c.gif";